import { render, staticRenderFns } from "./ManageFormsComponent.vue?vue&type=template&id=3afa54c2&scoped=true&"
import script from "./ManageFormsComponent.vue?vue&type=script&lang=js&"
export * from "./ManageFormsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ManageFormsComponent.vue?vue&type=style&index=0&id=3afa54c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa54c2",
  null
  
)

export default component.exports